import {gql} from '@apollo/client';

// Remove other result fields since server gives error
export const CREATE_USER_ADDRESS = gql`
  mutation createUserAddress($createAddressInput: CreateAddressInputType!) {
    createUserAddress(createAddressInput: $createAddressInput) {
      id
    }
  }
`;

export const UPDATE_USER_ADDRESS = gql`
  mutation updateUserAddress($addressId: String!, $updateAddressInput: UpdateAddressInputType!, $addressType: String) {
    updateUserAddress(addressId: $addressId, updateAddressInput: $updateAddressInput, addressType: $addressType) {
      id
    }
  }
`;

export const MARK_ADDRESS_DEFAULT = gql`
  mutation markAddressAsDefault($addressId: String!) {
    markAddressAsDefault(addressId: $addressId) {
      id
    }
  }
`;

export const GET_STORE_AREAS = gql`
  query getStoreAreas($filter: ThailandAreaInput, $suggestion: ThailandAreaInput, $pageNo: Float, $pageLength: Float) {
    getStoreAreas(filter: $filter, suggestion: $suggestion, pageNo: $pageNo, pageLength: $pageLength) {
      s
      p
      d
      z
      se
      de
      pe
      status
      sID
      dID
      pID
      st
    }
  }
`;

export const SYNC_MEMBERSHIP_CARDS = gql`
  query syncMakroMembershipCards {
    syncMakroMembershipCards {
      id
      cardNumber
      isDefault
      isLinked
      nameTh
      isNew
    }
  }
`;

export const GET_MEMBERSHIP_CARDS_WITH_POINTS = gql`
  query getMakroMembershipCards {
    getMakroMembershipCards {
      id
      cardNumber
      isDefault
      isLinked
      nameTh
      status
      alcoholExpiryDate
      name
      businessType
      alcoholOtpn
    }
  }
`;

export const GET_SUB_DISTRICTS = gql`
  query getStoreAreas($filter: ThailandAreaInput, $suggestion: ThailandAreaInput, $pageNo: Float, $pageLength: Float) {
    getStoreAreasV2(filter: $filter, suggestion: $suggestion, pageNo: $pageNo, pageLength: $pageLength) {
      result {
        de
        dID
        se
        sID
        z
        pe
        p
        s
        pID
        d
        status
      }
      pageCount
    }
  }
`;
